import { environment } from '../../../environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { NEVER, throwError } from 'rxjs';
import { signOut } from 'aws-amplify/auth';
import { inject } from '@angular/core';
import { StoreManager } from '../store/store.manager';
import { AppUrls } from '../../routing/app-urls';
import { Router } from '@angular/router';

export abstract class RequestServiceBase {

    protected storeManager = inject(StoreManager);
    protected router = inject(Router);

    protected resolveUrl(url: string) {
        return environment.api_url + url;
    }

    protected checkResponseBody(body: any): any {
        return body;
    }

    private async handleUnauthorized() {
        // call signout
        await signOut({ global: true });
        // reset all application state
        this.storeManager.resetState();
        // forward to analytics sign-out when not authorized, which clears the analytics session and redirects to sign-in
        this.router.navigate([AppUrls.signInUrl]);
    }

    protected handleError<T>(errorResponse: HttpErrorResponse) {
        if (errorResponse.status === 401) {
            this.handleUnauthorized();
            return NEVER;
        } else if (errorResponse.status === 400) {
            return throwError(errorResponse.error);
        } else if (errorResponse.status === 500) {
            return throwError(errorResponse.error);
        } else {
            return throwError(errorResponse.error);
        }
    }
}
